import type { FileItem } from "./types";

export function formatBytes(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  if (value < 1024) return `${value} B`;
  const units = ["KB", "MB", "GB", "TB", "PB"];
  let amount = value;
  let unit = -1;
  while (amount >= 1024 && unit < units.length - 1) {
    amount /= 1024;
    unit += 1;
  }
  return `${amount >= 100 ? amount.toFixed(0) : amount >= 10 ? amount.toFixed(1) : amount.toFixed(2)} ${units[unit]}`;
}

export function formatDate(value: number | null | undefined): string {
  if (!value) return "—";
  return new Intl.DateTimeFormat(undefined, { month: "short", day: "numeric", year: "numeric" }).format(new Date(value));
}

export function relativeDate(value: number | null | undefined): string {
  if (!value) return "No activity yet";
  const delta = Date.now() - value;
  const minute = 60_000;
  if (delta < minute) return "Just now";
  if (delta < 60 * minute) return `${Math.floor(delta / minute)}m ago`;
  if (delta < 24 * 60 * minute) return `${Math.floor(delta / (60 * minute))}h ago`;
  if (delta < 7 * 24 * 60 * minute) return `${Math.floor(delta / (24 * 60 * minute))}d ago`;
  return formatDate(value);
}

export function fileKind(file: Pick<FileItem, "name" | "kind" | "mimeType">): "folder" | "video" | "audio" | "image" | "document" | "archive" | "file" {
  if (file.kind === "folder") return "folder";
  if (file.mimeType.startsWith("video/")) return "video";
  if (file.mimeType.startsWith("audio/")) return "audio";
  if (file.mimeType.startsWith("image/")) return "image";
  if (file.mimeType.includes("pdf") || file.mimeType.startsWith("text/") || file.mimeType.includes("word") || file.mimeType.includes("spreadsheet") || file.mimeType.includes("presentation")) return "document";
  if (file.mimeType.includes("zip") || file.mimeType.includes("compressed") || /\.(zip|7z|rar|tar|gz)$/i.test(file.name)) return "archive";
  return "file";
}

export function fileExtension(name: string): string {
  const extension = name.split(".").pop();
  return extension && extension !== name ? extension.toUpperCase() : "FILE";
}

export function initials(value: string): string {
  return value.split(/\s+/).map((part) => part[0]).join("").slice(0, 2).toUpperCase() || "MC";
}

